export const AUTH0_CALLBACK_PATH = '/auth/callback';

let pendingReturnTo: string | null = null;

/**
 * Reduces a value to a safe same-origin path.
 *
 * `appState` survives a round trip through the Auth0 transaction, so it is treated as untrusted:
 * anything that could navigate off-origin (an absolute URL, a protocol-relative `//host` path) is
 * discarded rather than followed. Returning to the callback route itself would loop.
 */
export const sanitizeReturnTo = (value?: string | null): string => {
    if (!value || typeof value !== 'string') return '/';
    if (!value.startsWith('/')) return '/';
    if (value.startsWith('//')) return '/';
    if (value === AUTH0_CALLBACK_PATH || value.startsWith(`${AUTH0_CALLBACK_PATH}?`)) return '/';

    return value;
};

/** The path to come back to, captured before handing off to Auth0. */
export const currentReturnTo = (): string =>
    sanitizeReturnTo(window.location.pathname + window.location.search + window.location.hash);

export const setPendingReturnTo = (value?: string | null): void => {
    pendingReturnTo = sanitizeReturnTo(value);
};

export const takePendingReturnTo = (): string => {
    const value = pendingReturnTo ?? '/';
    pendingReturnTo = null;
    return value;
};
